<template>
    <div>
         <div class="main">
             <img style="position: absolute;top: -44px;" width="100%" height="228" src="icon/userIcon/integralbg.png" alt="">
            <div class="title">

                <div @click="back" style="margin-top:2px;" class="back">
                    <img src="icon/learnIcon/icon_liucheng_fanhui1.svg" alt="">
                </div>
                <div @click="showDrawer" class="fn_integral floatR">
                    学分说明
                </div>
            </div>
            <div class="integral_model">
                <div>
                    <div class="fn_meintegral">我的学分</div>
                    <div class="fn_sumintegral">{{integralSum}}</div>
                </div>
                <div @click="$router.push('/integralComp/integralDetail')" class="intergral_right">
                    <span class="fn_integral">学分明细</span>
                    <img width="12" height="12" style="vertical-align: middle;" src="icon/userIcon/integralright_icon.png" alt="">
                </div>
            </div>
        </div>

        <div class="content">

            <div data-notice="固定的图片，点击后，判断是否已绑定手机，然后前往企叮咚">
                <img class="w100p" src="integral/gift_banner.png" style="height: auto" @click="receiveGift()"/>
            </div>

            <!-- 做任务赚学分-->
            <div @click="$router.push('/operationMain/integral')" data-notice="固定的图片，点击前往签到领学分页">
                <img width="100%" height="auto" src="icon/userIcon/to_task_bg.jpg" alt="">
            </div>

        </div>
        <integral-drawer @hidden="hiddenShow" v-show="isShow"></integral-drawer>

        <courseConvertDrawer ref="convertDrawer" :userTotalIntegral="userTotalIntegral"/>

        <bindPhoneDrawer ref="bindPhoneDrawer" @bindSuccess="onBindPhoneSuccess"/>
        <bindPhoneSuccessDrawer ref="bindPhoneSuccessDrawer" @ok="onClickSuccessDrawerOk"/>

    </div>
</template>
<script>

// modules
import integralDrawer from './integralComp/integralDrawer.vue';
import courseConvertDrawer from '@comp/drawer/courseConvertDrawer.vue';
import bindPhoneDrawer from '@comp/drawer/bindPhoneDrawer';
import bindPhoneSuccessDrawer from '../integral/bindPhoneSuccessDrawer';

// part
import shixunPagePart from '@/components/shixunApp/shixunPagePart';

// config
import appConfig from '../../appConfig';

// data
import externalApp from '@data/externalApp';

// platformApi
import requestManager   from '@comp/platformApi/requestManager';

// api
import userApi from '@api/user';

// util
import consoleHelper from '@util/consoleHelper';
import appHelper from '@util/appHelper';
import wechatHelper from '@util/wechatHelper';

import {toDetailByBizType} from '@comp/shixunApp/toDetail';
import consoleApi from "@comp/platformApi/consoleApi";


const config = {
    apiConfig : {
        list : {
            url : '/portal/v4/user/center/integral/getIntegralVodList',
            // totalPagePath : 'data.pages',
            dataPath : 'data',
            totalPath : 'data.total',
            totalPagePath : 'data.pages'
        }
    }
};


export default {
    name:'integral',
    extends : shixunPagePart,

    data(){
        return{
            isShow:false,
            integralSum:0,
            enableDataList : true,
            autoLoadDataList : true,
            scrollToLoadNextPage:false,
            apiConfig : config.apiConfig,

            title:'学分',
            desc:'',
            userTotalIntegral : 0,

            toDetailByBizType:toDetailByBizType,

            isBindedPhone : false,
        }
    },
    components:{
        integralDrawer, courseConvertDrawer, bindPhoneDrawer, bindPhoneSuccessDrawer
    },
    methods:{

        back(){
             appHelper.back(this)
        },
        showDrawer(){
            this.isShow = true
        },
        hiddenShow(){
            this.isShow = false
        },

        setWechatShare : function()
        {

            let wechatShareOptions = {
                title   : appHelper.getTitle(),
                desc    : this.desc,
                link    : location.href,
                imgUrl  : appHelper.getAppIcon() // 分享图标
            };
            wechatHelper.setShare(wechatShareOptions);
        },

        convert(dataItem) {
            this.openConvertDrawer({
                id : dataItem.id || '',
                vodId : dataItem.vodId || '',
                title : dataItem.title || '',
                image : dataItem.coverImg || '',
                // vodType : urlHelper.getUrlParam('vodType') || '',
                integralValue : dataItem.integralValue || ''
            });
        },
        openConvertDrawer : function (productData) {
            this.$refs.convertDrawer.setProduct(productData);
            this.$refs.convertDrawer.open();
        },

        receiveGift() {

            if (!this.isBindedPhone)
            {
                this.$refs.bindPhoneDrawer.open();
            }
            else
            {
                appHelper.redirect(externalApp.qiDingDong.url);
            }
        },

        onBindPhoneSuccess() {

            this.$refs.bindPhoneDrawer.close();
            this.$refs.bindPhoneSuccessDrawer.open();
            this.getOrderAwardIntegral();
        },
        onClickSuccessDrawerOk() {
            appHelper.redirect(externalApp.qiDingDong.url);
        }
    },

    mounted(){

        appHelper.checkLogin((error, result) => {

            if (error)
            {
                return;
            }

            if (!result)  // 游客
            {
                consoleApi.log('result:', result);
                return;
            }

            requestManager.request(userApi.userTotalIntegral, (error, result) => {
                this.integralSum = result.data;
            });

            //
            requestManager.request(userApi.userTotalIntegral, (error, result) => {
                if (error)
                {
                    consoleHelper.logError(error);
                    return;
                }

                if (result.errorCode)
                {
                    appHelper.showHint(result.errorCode + ': ' + result.msg);
                    consoleHelper.logError(result.errorCode + ': ' + result.msg);
                    return;
                }

                this.userTotalIntegral = result.data;
            });

            requestManager.request(userApi.isBindPhone, (error, result) => {
                if (error)
                {
                    return;
                }

                this.isBindedPhone = result.data;

            });

        });

    }
}
</script>
<style lang="scss" scoped>

.main{
   width: 100%;
   height: 139px;
   position: relative;
}

.title{
    position: absolute;
    top: 0;
    left: 3%;

    width: 94%;
    height: 44px;
    text-align: center;
    line-height: 44px;



}

.fn_integral{
    font-size: 14px;
    font-weight: 400;
    color: #492100;

}
.fn_meintegral{
    font-size: 12px;
    font-weight: 400;

    color: #4D2501;

}
.fn_sumintegral{

    font-size: 36px;
    font-weight: 500;
    color: #4D2501;

}

.back{
    float: left;
    margin-top: 16px;
}

.content{
    width: 100%;
    padding:0 4%;
    padding-top: 16px;
    box-sizing: border-box;
    background: #fff;
    position: relative;
    border-radius: 14px 14px 0px 0px;
}

.integral_model{
    position: absolute;
    top: 60px;
    left: 3%;
    width: 94%;
    display: flex;
    justify-content: space-between;
    .intergral_right{
        height: 100%;
        line-height: 60px;
    }
}

.content_title{
    .title_fn{

    font-size: 18px;
    font-weight: 400;
    color: #2C2C2C;

    }
    .title_exple{

    font-size: 12px;

    font-weight: 400;
    color: #999999;

    }
}

.content_item{
    width: 100%;
    height: 56px;
    margin-top: 20px;
    display: flex;

}

.content_list{
    padding-bottom: 20px;
}

.flex_item{
    flex: 1;
    display: flex;
    align-items: center;
    .img_item{
        width: 80px;
        height: 56px;
        background: #999;
        border-radius: 4px;
        img{
            width: 100%;
            height: 100%;
            border-radius: 4px;
            object-fit: cover;
        }
    }

    .img_title{
        flex: 1;
        display: flex;
        flex-direction:column;
        justify-content: space-between;
        min-height: 56px;
        padding-left: 8px;
        .fn_title{
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;


            font-size: 14px;
            font-weight: 400;
            color: #2C2C2C;

        }
        .fn_coin{

            font-size: 14px;
            font-weight: 400;

            color: #FF3D38;

        }
    }
}

.right_item{
    text-align: center;
    // height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: 6px;
     .btn_item{

        width: 70px;
        height: 28px;
        box-sizing: border-box;
        padding: 5px 11px;

        background: linear-gradient(90deg, #FFA724 0%, #FFBF60 100%);

        border-radius: 16px;


        font-size: 12px;

        font-weight: 400;
        color: #FFFFFF;

    }
    .yes_coin{

        font-size: 10px;

        font-weight: 400;
        color: #999999;

    }
}






</style>
